
import React, { useEffect, useState, forwardRef, useRef } from "react";
import ReactToPrint, { PrintContextConsumer, useReactToPrint } from "react-to-print";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import Paper from '@mui/material/Paper';
import dayjs from 'dayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import {
    Box, Button, Grid, Dialog, DialogTitle, TextField, DialogActions, Popper,
    TablePagination, Typography, InputAdornment, DialogContent, IconButton, Tooltip, Card, CardContent, Container, Popover, Divider, Hidden, Snackbar, Autocomplete, ButtonGroup, Grow, ClickAwayListener, MenuList, MenuItem
} from '@mui/material';
import { Icon } from '@iconify/react';
import SyncAltIcon from '@mui/icons-material/SyncAlt';

import Breadcrumb from "../../reusableComponent/Breadcrumb";
import { StyledTableRow, StyledTableCell } from '../../reusableComponent/StyledTable'

import { useDispatch, useSelector } from "react-redux";
import { editDeletePurchaseInvoice, getCNSList, getPurchaseInvoiceList, getSaleInvoiceList, getSalesOrderHistoryReport } from "../../../actions/actions";

import { dateConversion } from "../../reusableComponent/dateConversionOnEntryPage";
import styles from '.././../../styles.module.css';
import ExcelDownload from "../../reusableComponent/ExcelDownload";
import { ERPinput } from "../../reusableComponent/ErpTextField";
import { makeStyles } from "@mui/styles";
import download_excel from '../../../images/download_excel1.png'
import { DownloadTableExcel } from 'react-export-table-to-excel';
import { getDateFormat } from "../../reusableComponent/getDateFormat";
import * as FileSaver from 'file-saver';
import XLSX from 'sheetjs-style';
import SalesOrderHistoryPrint from "./SalesOrderHistoryPrint";
import { BackBtn } from "../../reusableComponent/BackBtn";

const useStyles = makeStyles({
    option: {
        fontSize: 12,
    },
    noOptionsLabel: {
        fontSize: '12px',
    },

});

const ComponentToPrintRow = forwardRef((props, ref) => {
    const { value } = props;
    return (
        <div className="print-source" ref={ref}>
            <SalesOrderHistoryPrint reportPrint={value} />
        </div>
    );
});

const ComponentToPrintOrderWrapper = ({ reportPrint }) => {

    const ref = useRef();
    return (
        <div style={{ display: "flex" }}>
            <ReactToPrint
                trigger={() => <span style={{ display: 'flex', justifyContent: 'center' }}>  <Icon icon="flat-color-icons:print" width="20" height="20" /> </span>}
                content={() => ref.current}
            />
            <div style={{ display: 'none' }}>
                <ComponentToPrintRow ref={ref} value={reportPrint} />
            </div>
        </div>
    );
};

function SalesOrderHistory(props) {

    const classes = useStyles();
    const dispatch = useDispatch();
    const login_details = sessionStorage.getItem('loginUser');
    const userD = JSON.parse(login_details);
    const userInfo = userD.userInfo;
    let ref = useRef();
    const tableRef = useRef(null);
    const [fromDate, setFromDate] = React.useState(dayjs(new Date()));
    const [toDate, setToDate] = React.useState(dayjs(new Date()));
    const [customerName, setCustomerName] = useState(null);
    const customerList = useSelector(state => state.CNS.CNS)
    const rows = useSelector(state => state.salesOrderHistory.salesOrderHistory)

    const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset-UTF-8';
    const fileExtension = '.xlsx';
    const fileName = 'SalesOrderHistory'
    const [enablePagination, setEnablePagination] = useState(false)

    const exportToExcel = () => {
        setEnablePagination(true)
        setTimeout(() => {
            const table = tableRef.current;
            const data = [];

            const headerRow = [];
            table.querySelectorAll('thead > tr > th').forEach((headerCell) => {
                const boldStyle = {
                    font: { bold: true },
                };
                const cellValue = { v: headerCell.textContent, s: boldStyle };
                headerRow.push(cellValue);
            });
            data.push(headerRow);

            table.querySelectorAll('tbody > tr').forEach((row) => {
                const rowData = [];
                row.querySelectorAll('td').forEach((cell) => {
                    rowData.push(cell.textContent);
                });
                data.push(rowData);
            });

            const ws = XLSX.utils.aoa_to_sheet(data);

            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, 'data');

            const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });

            const blob = new Blob([excelBuffer], { type: fileType });

            FileSaver.saveAs(blob, fileName + fileExtension);
            setEnablePagination(false);
        }, 50);
    };

    const handleChangeFromDate = (newValue) => {
        setFromDate(newValue);
        dispatch(getSalesOrderHistoryReport({ companyId: userInfo.companyId, CNS_id: customerName == null ? null : customerName.CSNId, fromDate: getDateFormat(newValue.$d), toDate: getDateFormat(toDate.$d) }))
    };

    const handleChangeToDate = (newValue) => {
        setToDate(newValue);
        dispatch(getSalesOrderHistoryReport({ companyId: userInfo.companyId, CNS_id: customerName == null ? null : customerName.CSNId, fromDate: getDateFormat(fromDate.$d), toDate: getDateFormat(newValue.$d) }))
    };

    const handleChangeCustomer = (event, newValue) => {
        setCustomerName(newValue)
        dispatch(getSalesOrderHistoryReport({ companyId: userInfo.companyId, CNS_id: newValue == null ? null : newValue.CSNId, fromDate: getDateFormat(fromDate.$d), toDate: getDateFormat(toDate.$d) }))
    }

    const fetchData = () => {
        dispatch(getSalesOrderHistoryReport({ companyId: userInfo.companyId, CNS_id: customerName, fromDate: getDateFormat(fromDate.$d), toDate: getDateFormat(toDate.$d) }))
        dispatch(getCNSList({ financialYear: userInfo.financialYear, companyId: userInfo.companyId, CNS_Type: 'Customer' }));
    };

    const [rowsPerPage, setRowsPerPage] = React.useState(10)
    const [page, setPage] = React.useState(0)

    const handleChangePage = (event, newPage) => {
        setPage(newPage)
    }

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value)
        setPage(0)
    }

    useEffect(() => {
        fetchData()
    }, []);

   
    const CustomTableRow = ({ row }) => (
        <>
            <StyledTableRow
                key={row.pi_id}
                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
                <StyledTableCell align="left" className={`${styles.list_table_body}`}>{row.salesOrderNo}</StyledTableCell>
                <StyledTableCell align="left" className={`${styles.list_table_body}`} > {dateConversion(row.salesOrderDate)} </StyledTableCell>
                <StyledTableCell align="left" className={`${styles.list_table_body}`}>{row.customerName == null ? '-' : row.CNS_Name}</StyledTableCell>
                <StyledTableCell align="left" className={`${styles.list_table_body}`}>{row.itemId == null ? row.itemDescription : row.itemName + ' (' + row.itemCode + ')'}</StyledTableCell>
                <StyledTableCell align="right" className={`${styles.list_table_body}`}>{row.quantity}</StyledTableCell>
                <StyledTableCell align="right" className={`${styles.list_table_body}`}>{row.quantity}</StyledTableCell>
                <StyledTableCell align="right" className={`${styles.list_table_body}`}>0</StyledTableCell>
            </StyledTableRow>
        </>
    );
    return (
        <>
            <Breadcrumb
                routeSegments={[
                    { name: 'Reports', path: '/reports/' },
                    { name: 'Sales Order History' },
                ]}
            />
            <Paper className={`${styles.list_container}`}>

                <Box sx={{ display: 'flex' }}>
                    <Grid container spacing={0.2} sx={{ pt: 0.5, pb: 0.5 }}>
                        <Grid item md={4.5} xs={12}>
                            {/* <Typography className={`${styles.page_title}`}>Sales Order History </Typography> */}
                        </Grid>
                        <Grid item md={7.5} xs={12} style={{ display: 'flex', }}>
                            <Grid container spacing={1} >
                                {/* <Grid item xs={1}>
                                    <Typography className={`${styles.erp_lable}`}> From Date</Typography>
                                </Grid> */}
                                <Grid item xs={2}>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DesktopDatePicker
                                            name="fromDate"
                                            inputFormat="DD/MM/YYYY"
                                            value={fromDate}
                                            onChange={handleChangeFromDate}
                                            renderInput={(params) => (<Tooltip title="Select From Date"> <ERPinput  {...params} size='small'
                                                fullWidth /> </Tooltip>)}
                                        />
                                    </LocalizationProvider>
                                </Grid>
                                <Grid item xs={0.8} sx={{ display: 'flex', justifyContent: 'center', }}>
                                    <SyncAltIcon sx={{ fontSize: '20px', textAlign: 'center' }} />
                                    {/* <Typography className={`${styles.erp_lable}`}> To Date</Typography> */}
                                </Grid>
                                <Grid item xs={2}>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DesktopDatePicker
                                            name="toDate"
                                            inputFormat="DD/MM/YYYY"
                                            value={toDate}
                                            onChange={handleChangeToDate}
                                            renderInput={(params) => (<Tooltip title="Select To Date" > <ERPinput
                                                {...params} size='small'
                                                fullWidth /> </Tooltip>)}
                                        />
                                    </LocalizationProvider>
                                </Grid>
                                <Grid item xs={6.2}>
                                    <Autocomplete sx={{ marginBottom: '10px' }}
                                        fullWidth
                                        classes={{
                                            option: classes.option,
                                        }}
                                        noOptionsText={
                                            <span className={classes.noOptionsLabel}>No options</span>
                                        }
                                        options={customerList}
                                        value={customerName}
                                        onChange={handleChangeCustomer}
                                        getOptionLabel={(option) => option.CNS_Name}
                                        getOptionSelected={(option, value) => option.id === value.CSNId}
                                        renderInput={(params) => <ERPinput required
                                            placeholder="Select Customer"
                                            {...params} />}
                                    />
                                </Grid>
                                <Grid item xs={0.5}>
                                    <Box className={`${styles.excel_box}`}>
                                        <Tooltip title="Download Excel File" >
                                            {/* <DownloadTableExcel
                                                filename='SalesOrderHistory'
                                                sheet='Sales Order History'
                                                currentTableRef={tableRef.current}
                                            >
                                                <img src={download_excel} style={{ height: "20px", width: "20" }} />
                                            </DownloadTableExcel> */}
                                            <img src={download_excel} onClick={exportToExcel} style={{ height: "20px", width: "20" }} />

                                        </Tooltip>
                                    </Box>
                                </Grid>
                                <Grid item xs={0.5}>
                                    <Box className={`${styles.excel_box}`}>
                                        <Tooltip title="Print Report">
                                            <ComponentToPrintOrderWrapper reportPrint={rows} />
                                        </Tooltip>
                                    </Box>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Box>
                <TableContainer component={Paper} style={{ overflowY: 'auto', maxHeight: 450 }}>
                    <Table sx={{ minWidth: 650 }} size="small" stickyHeader ref={tableRef}>
                        <TableHead>
                            <StyledTableRow>
                                <StyledTableCell align="left" className={`${styles.table_head}`} >SO No </StyledTableCell>
                                <StyledTableCell align="left" className={`${styles.table_head}`}>SO Date </StyledTableCell>
                                <StyledTableCell align="left" className={`${styles.table_head}`}>Customer Name</StyledTableCell>
                                <StyledTableCell align="left" className={`${styles.table_head}`} >Item Description</StyledTableCell>
                                <StyledTableCell align="right" className={`${styles.table_head}`} >Order Quantity</StyledTableCell>
                                <StyledTableCell align="right" className={`${styles.table_head}`} > Delivery Quantity</StyledTableCell>
                                <StyledTableCell align="right" className={`${styles.table_head}`} > Pending Quantity</StyledTableCell>
                            </StyledTableRow>
                        </TableHead>
                        <TableBody>
                            {
                                enablePagination === false ? (
                                    rows && rows.map((row, index) => (
                                            <CustomTableRow key={row.pi_id} row={row} />
                                        ))
                                ) : (
                                    rows.map((row, index) => (
                                        <CustomTableRow key={row.pi_id} row={row} />
                                    ))
                                )
                            }

                        </TableBody>
                    </Table>
                </TableContainer>
               
            </Paper>
        </>
    )
}



export default SalesOrderHistory